import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatTableDataSource } from '@angular/material/table';
import { Companion } from '../models/companion';
import { CompanionService } from '../services/companion.service';
import { MemberService } from '../services/member.service';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-companion',
  templateUrl: './companion.component.html',
  styleUrls: ['./companion.component.scss']
})
export class CompanionComponent implements OnInit {

  public entityForm: FormGroup;
  public searchMemberControl: FormControl;

  public members: any[] = []
  public flagSelected: boolean = false;

  public matcher = new FormErrorStateMatcher();
  public spinner: boolean;

  public dataSource: MatTableDataSource<any>
  public displayedColumns: string[] = ['icon', 'member_name', 'name'];

  constructor(
    private fb: FormBuilder,
    private _memberService: MemberService,
    private _companionService: CompanionService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.entityForm = this.createForm()

    this.initializeAutoCompletes()

  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [Validators.required]),
      member_id: new FormControl('', [Validators.required]),
      member_name: new FormControl('', [Validators.required]),
      member_email: new FormControl(''),
      date: new FormControl(''),
    });
    return form
  }


  // AUTOCOMPLETES

  initializeAutoCompletes() {

    this.searchMemberControl = new FormControl();
    this.searchMemberControl.valueChanges.subscribe(val => {
      if (val != undefined) this.updateMemberSearchList(val);
    })

  }



  registerCompanion() {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {
        title: "Confirme", message: "Deseja registrar<br>" + this.entityForm.controls.name.value +
          "<br><br>como acompanhante de<br>" + this.entityForm.controls.member_name.value + "?"
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        const entity: any = {
          'name': this.entityForm.controls.name.value,
          'member_id': this.entityForm.controls.member_id.value,
          'member_name': this.entityForm.controls.member_name.value,
          'member_email': this.entityForm.controls.member_email.value,
          'date': new Date()
        }

        this._companionService.insert(entity)
          .then(() => {
            this.printDiv(entity)
          })

      }
    })
  }





  printDiv(data) {

    let companion = data

    let html: string = "";
    html += "<div style='height: 180px; padding-top: 20px; border-bottom: solid 1px silver;'>"
    html += companion.name
    html += "</div>";

    var mywindow = window.open('', 'PRINT', 'height=600,width=800');

    mywindow.document.write('<html>');
    mywindow.document.write('<body>');
    mywindow.document.write(html);
    mywindow.document.write('</body>');
    mywindow.document.write('</html>');

    mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/

    mywindow.print();
    mywindow.close();

    return true;
  }



  // MEMBERS AUTOCOMPLETE

  cleanMemberSearch() {
    this.members = []
  }

  updateMemberSearchList(val) {

    if (val.length > 3) {

      this._memberService.selectStartAt(val)
        .subscribe((result) => {

          this.members = []

          result.forEach((item) => {
            this.members.push({
              "member_id": item.id,
              "member_name": item.data().name,
              "member_email": item.data().email
            })

          })

        })

    }
  }

  displayMember(value) {

    if ((value !== null) && (value !== undefined) && (value !== "")) {

      this.entityForm.controls.member_id.setValue(value.member_id);
      this.entityForm.controls.member_name.setValue(value.member_name);
      this.entityForm.controls.member_email.setValue(value.member_email);

      //get list of comanions
    //  console.log(value.member_id)
      this._companionService.selectByMember(value.member_id)
        .subscribe((result) => {
          let array = result.map(item => {
            let entity = new Companion();
            entity.id = item.payload.doc.id;
            entity.name = item.payload.doc.data().name;
            entity.member_id = item.payload.doc.data().member_id;
            entity.member_name = item.payload.doc.data().member_name;
            entity.date = item.payload.doc.data().date;
            return entity;
          });

          this.dataSource = new MatTableDataSource(array);

        })

      this.flagSelected = true
      return value.member_name;

    } else {
      return "";
    }

  }

  // FIM AUTOCOMPLETE


}
